<template>
  <yv-form-search
    :formSearch="formSearch"
    :inlineSearchAction="true"
    :enableExport="false"
    @search="search"
    ref="formSearch"
  >
    <template #search-actions="{ actions }">
      <div class="flex justify-between">
        <md-button
          native-type="submit"
          @click.native.prevent="actions.search"
          class="md-info md-round"
          >{{ $t("common.report") }}
        </md-button>
      </div>
    </template>
  </yv-form-search>
</template>

<script>
import YvFormSearch from "@/components/Base/YvFormSearch.vue";
import { service_paths } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";
import { attendanceStatus } from "../../../../helpers/text-helper";

export default {
  components: { YvFormSearch },
  data() {
    return {
      formSearch: [
        {
          label: this.$t("class.col_class_name"),
          name: "class_id",
          value: "",
          displayValue: "",
          options: [],
          type: "autocomplete",
          fields: {
            text: "displayName",
            value: "id"
          },
          searchKey: "classes__name__~",
          refetchOptions: this.fetchClassOpts
        },
        {
          label: this.$t("class.student_filter_id_fullname"),
          name: "user_id",
          value: "",
          displayValue: "",
          options: [],
          type: "autocomplete",
          fields: {
            text: "name",
            value: "id"
          },
          searchKey: "username__~",
          refetchOptions: this.fetchStudentOptsByClass,
          isDisabled: true,
          width: 30
        },
        {
          label: this.$t("common.status"),
          name: "status[]",
          value: [],
          type: "checkbox-multi-select",
          options: [],
          trackBy: "id",
          displayField: "name",
          showSelectAll: true
        }
      ]
    };
  },
  created() {
    this.fetchClassOpts();
    this.getStatus();
    this.formSearch[2].value = ["Ex.absence", "Unex.absence"];
  },
  computed: {
    selectedClassId() {
      return this.formSearch[0].value;
    },
    selectedStudentId() {
      return this.formSearch[1].value;
    }
  },
  methods: {
    search(queryParams) {
      if (!this.selectedClassId || !this.selectedStudentId) {
        Message.error(this.$t("daily_attendance.data_empty_class_student"));
        return;
      }
      if (
        queryParams["status[]"].length === 5 ||
        queryParams["status[]"].length === 0
      ) {
        queryParams["status[]"] = "";
      }
      this.$emit("set-new-report-params", {
        ...queryParams
      });
    },
    fetchClassOpts(queryObj) {
      return this.$axios
        .get(
          `${service_paths.classes}/current-user`,
          queryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          this.formSearch[0].options = response.data.data.map(element => ({
            id: getId(element),
            displayName: element.name
          }));
        });
    },
    fetchStudentOptsByClass(queryObj) {
      return this.$axios
        .get(
          `${service_paths.classes}/${this.selectedClassId}/students`,
          queryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          let options = [];
          response.data.data.forEach(student => {
            options.push({
              id: getId(student),
              name: student.student_code
                ? `${student.full_name} - ${student.student_code}`
                : student.full_name
            });
          });
          this.formSearch[1].options = options;
        });
    },
    getStatus() {
      const statusList = [];
      for (let key in attendanceStatus) {
        statusList.push({ id: key, name: attendanceStatus[key] });
      }
      this.formSearch[2].options = statusList;
    }
  },
  watch: {
    selectedClassId: function(newSelectedClassId) {
      this.formSearch[1].isDisabled = false;
      if (!newSelectedClassId) {
        this.formSearch[1].options = [];
        this.formSearch[1].displayValue = "";
        this.formSearch[1].value = "";
        this.formSearch[1].isDisabled = true;
        return;
      }
      this.fetchStudentOptsByClass();
    },
    selectedStudentId: function(newSelectedStudentId) {
      return newSelectedStudentId;
    }
  }
};
</script>

<style lang="scss" scoped></style>
